<ng-container *ngIf='!inputService.hidden && inputService.formInputDefinition && inputService.control' [formGroup]="inputService.formGroup">
	<mat-form-field>
		<mat-label>{{inputService.computedTitle | translate}}</mat-label>
		<input autocomplete="off" type='password' matInput [placeholder]="(inputService.inputConfig.placeholder || '') | translate" [formControlName]='inputService.formControlKey'>
		<mat-hint *ngIf='inputService.inputConfig.hint'>{{inputService.inputConfig.hint | translate}}</mat-hint>
		<mat-error *ngIf="!inputService.control.valid">{{inputService.errorMessage | translate}}</mat-error>
	</mat-form-field>
</ng-container>